import React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { withRouter, Route, Redirect } from 'react-router-dom';

// import InformationCategory from './InformationCategory';
// import InformationCategoryList from './InformationCategoryList';

import List from './List';
import Edit from './Edit';

import { Tags } from 'root/admin/components';

import store from 'root/admin/store';
import { Loader, TabMenu, MenuItem } from '@smartplatform/ui';

const menuItems = [
	{
		label: 'Ссылки',
		id: 'links',
	},
	{
		label: 'Категории',
		id: 'tags',
	},
];

// @withRouter
@observer
export default class Link extends React.Component {
	@observable tab;

	switchTab = record => {
		this.tab = record.id;
		this.props.history.push(`/admin/links/${record.id}`);
		store.ui.setPage(record.id);
	};

	render() {
		console.log('path', store.route.path);
		if (store.route.path === '/admin/links') {
			return <Redirect to="/admin/links/links" />;
		}

		const rootPath = '/admin/links';
		return (
			<div>
				<TabMenu>
					{menuItems.map(record => (
						<MenuItem
							key={`category-${record.id}`}
							label={record.label}
							onClick={() => this.switchTab(record)}
							active={store.ui.page === record.id}
						/>
					))}
				</TabMenu>

				<Route exact path={`/admin/links/links`} component={() => <List rootPath={rootPath} />} />
				<Route exact path={`/admin/links/links/:id`} component={() => <Edit rootPath={rootPath} />} />
				<Route path={`/admin/links/tags`} component={() => <Tags model="link" />} />
			</div>
		);
	}
}
